import CartItem from '@vue-storefront/core/modules/cart/types/CartItem'
import config from 'config'
import omit from 'lodash-es/omit'
import pullAll from 'lodash-es/pullAll'

const optimizeProduct = (product: CartItem): CartItem => {
  if (!config.entities.optimizeShoppingCart) {
    return product
  }

  let fieldsToOmit = config.entities.optimizeShoppingCartOmitFields

  if (config.cart.productsAreReconfigurable) {
    fieldsToOmit = pullAll(fieldsToOmit, ['configurable_children', 'configurable_options'])
  }

  // Keep manage_stock after omitting full `stock` — needed for unmanaged (Muster) availability in cart/checkout
  const manageStock = product && product.stock ? product.stock.manage_stock : undefined
  const optimized: CartItem = omit(product, fieldsToOmit) as CartItem

  if (manageStock === false || manageStock === 0 || manageStock === true || manageStock === 1) {
    optimized.stock = { manage_stock: manageStock }
  }

  return optimized
}

export default optimizeProduct
